export default __webpack_public_path__ + "static/media/grafema_ummi_18.3e31bfef.jpg";